export const environment = {
  apiUrl: '',
  leoApiUrl: 'https://leo-develop.mytrusteddriver.com',
  mapKey: 'pk.eyJ1IjoiZGV2dHJ1c3RlZGRyaXZlciIsImEiOiJjbGd5bHZuaHgwN3hzM2ZubTl6eXBlZWZ1In0.VVBM91z_1vyb6jJPskNMyw',
  measurementId: 'G-1GW1CCJQG3',
  keycloak: {
    url: 'https://auth-develop.mytrusteddriver.com',
    realm: 'leo',
    clientId: 'analytic-frontend',
  },
  app_path: '',
};
